import { List } from 'immutable';

/**
 * Get error list from error response.
 *
 * @param response {Object} Error response object.
 */
export default function getErrorResponse(response) {
  if (!response) {
    return List([]);
  }

  const { errors } = response;
  let ret = [];

  if (errors) {
    for (const prop in errors) {
      if (Object.prototype.hasOwnProperty.call(errors, prop)) {
        ret = ret.concat(errors[prop]);
      }
    }
  } else {
    ret = [response.message];
  }

  return List(ret);
}
